<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fire`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.462 3l-.001.901c-.005 6.494.212 10 1.182 12.648.092-.256.184-.496.274-.708 1.189-2.8 2.997-4.81 5.692-5.629l2.598-.79-.016 2.716c-.018 2.925.48 4.882 1.75 7.926l.313.746.037.087c.141.338.248.597.351.852.925 2.299 1.358 4.055 1.358 6.189C43 38.438 34.97 47 25 47 14.876 47 6 38.287 6 27.938c0-5.093 2.072-10.054 5.81-12.106l2.568-1.409.378 2.905a17.037 17.037 0 00.262 1.324c.184.768.418 1.534.704 2.265.114-2.473.419-4.748 1.028-7.148 1.533-6.034 4.704-10.51 9.965-12.625L29.462.04V3zm8.14 19.444l-.353-.84c-.901-2.161-1.483-3.92-1.79-5.787a8.655 8.655 0 00-.86 1.588c-.289.678-.704 2.15-1.026 3.29-.217.769-.391 1.386-.456 1.51-.206.398-.472.726-.961.974-.839.426-1.75.226-2.357-.334l-.113-.104-.096-.12c-3.25-4.073-4.017-7.47-4.117-16.186-2.348 1.856-3.92 4.678-4.846 8.319-.829 3.263-1.025 6.363-.943 10.316-.003-.145.013.585.015.734.005.253.005.433.002.587a2.757 2.757 0 01-.156.947c-.034.089-.08.172-.212.412-.378.505-.378.505-1.39.884-.996-.066-1.068-.07-1.473-.364-1.757-1.07-3.08-2.787-4.071-4.948-.28-.61-.525-1.236-.737-1.871C10.622 23.148 10 25.504 10 27.938 10 36.06 17.069 43 25 43c7.702 0 14-6.716 14-15.062 0-1.54-.318-2.83-1.069-4.696a59.012 59.012 0 00-.33-.799z"/></svg>
</template>
<script>

export default {
  name: 'IconFire',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
